import ids from 'Components/Worksheets/QestIds';
import { WorksheetBatchUpdateDefinition } from '.';
import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from './Core/SharedQueryFields';
import { AsDynamicConePenetrometerBatchUpdateDefinition } from './DynamicConePenetrometer';
import { IhmHandShearVaneBatchUpdateDefinition } from './HandShearVane/InHouseMethod';
import { ArizNuclearFieldDensityBatchUpdateDefinition } from './NuclearFieldDensity/Ariz';
import { AsNuclearFieldDensityBatchUpdateDefinition } from './NuclearFieldDensity/As';
import { BsNuclearFieldDensityBatchUpdateDefinition } from './NuclearFieldDensity/Bs';
import { AsRelativeCompactionBatchUpdateDefinition } from './RelativeCompaction/As';
import { BsSandReplacementBatchUpdateDefinition } from './SandReplacement/Bs';

/**
 * Maps the worksheet type id (a.k.a. QestID) to its batch update page definition
 */
export const WorksheetBatchUpdateDefinitions: { [typeId: string]: WorksheetBatchUpdateDefinition } = {
  [ids.nuclearFieldDensity.BS_1377_9_Clause_2_5.rev1990]: BsNuclearFieldDensityBatchUpdateDefinition,
  [ids.nuclearFieldDensity.AS_1289_5_8_1.rev2007]: AsNuclearFieldDensityBatchUpdateDefinition,
  [ids.nuclearFieldDensity.ARIZ_235.rev1992]: ArizNuclearFieldDensityBatchUpdateDefinition,
  [ids.sandReplacement.BS_1377_9_Clause_2_2.rev1990]: BsSandReplacementBatchUpdateDefinition,
  [ids.handShearVane.InHouseMethod]: IhmHandShearVaneBatchUpdateDefinition,
  [ids.relativeCompaction.AS_1289_5_4_1.rev2007]: AsRelativeCompactionBatchUpdateDefinition,
  [ids.dynamicConePenetrometer.AS_1289_6_3_2.rev1997]: AsDynamicConePenetrometerBatchUpdateDefinition,
};

/**
 * A special batch update type id for when all test types are to be shown
 */
export const WorksheetBatchUpdateAllTestsTypeId = 'all-tests';

export const getWorksheetBatchUpdateDefinition = (typeId: string) =>
  WorksheetBatchUpdateDefinitions[typeId] ?? DefaultWorksheetBatchUpdateDefinition;

/**
 * The default worksheet batch update definition to use for types
 * without an explicit definition or when all tests are shown
 *
 * Essentially this uses the generic worksheet endpoint to obtain basic details
 *  and only allows batch checking to be performed.
 */
const DefaultWorksheetBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Worksheet',
  query: {
    defaultParams: {
      ...WorksheetBatchUpdateCommonDefaultParams,
      ExpandBody: 'false',
      IncludeNonWebAppWorksheets: 'true',
      OrderBy: 'SampleSampleId asc',
    },
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
    requestParamRenameMap: {
      WorkOrder: 'WorkOrderId',
      TypeId: 'WorksheetTypeId',
    },
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: {},
  worksheetFieldSections: {},
};
